/* eslint-disable no-await-in-loop */

// 轨道类型枚举
// const EnumKFTTNone = 0 // 未知类型,预留,动画轨道中不会出现该类型
// const EnumKFTTDouble = 1 // double类型
// const EnumKFTTReal2 = 2 // 二维向量(double2)类型
const EnumKFTTReal3 = 3 // 三维向量(double3)类型
// const EnumKFTTReal4 = 4 // 四维向量(double4)类型
const EnumKFTTQuaternion = 5 // 四元数(quat<double>)类型
// const EnumKFTTColor = 6 // 颜色(Rgba)类型
// const EnumKFTTBool = 7 // bool类型
// const EnumKFTTString = 8 // 字符串(std::string) 类型

// 轨道属性链接类型枚举
// const EnumAPBTNone = 0 // 无绑定(或者不希望使用系统的绑定类型)
const EnumAPBTTranslation = 1 // 位置属性绑定
const EnumAPBTRotation = 2 // 旋转属性绑定
// const EnumAPBTScaling = 3 // 缩放属性绑定
// const EnumAPBTVisible = 4 // 可见性属性绑定
// const EnumAPBTColor = 5 // 颜色属性绑定
// const EnumAPBTUV = 6 // UV属性绑定

// 轨道插值方式类型枚举
const EnumITLinear = 0 // 线性插值
// const EnumITCubic = 1 // 三次插值
const EnumITDiscrete = 2 // 离散插值,曲线的值保持不变，直到下一个关键帧(比如 BoolKeyframeTrack, StringKeyframeTrack)

// 动画控制器循环模式枚举
const EnumLMLoopOnce = 0 // 只执行一次
// const EnumLMLoopRepeat = 1 // 重复次数为repetitions的值,且每次循环结束时自动回到下一次循环的开始
// const EnumLMLoopPingPong = 2 // 重复次数为repetitions的值,且特么的就像乒乓球一样在起始点和结束点之间来回循环

const addKeyframe = async (timePositions, trackT, trackR, player) => {
  const trackTList = [] // 直线点list
  const trackRList = [] // 旋转四元数list
  for (let i = 0; i < timePositions.length; i += 1) {
    const timePosition = timePositions[i]
    // 添加位置关键帧
    // player.Native.KeyframeTrack.keyAppend(trackT, timePosition.time, timePosition.point)
    const tempT = {
      keyframeTrack: trackT,
      time: timePosition.time,
      value: timePosition.point,
    }
    trackTList.push(tempT)
    // 计算当前关键帧时的旋转四元素并添加旋转关键帧 (节点始终超路径方向)
    if (i < timePositions.length - 1) {
      const nextTimePosition = timePositions[i + 1]
      let rotMat = Matrix4.identity()
      const initFrontDir = [0, -1, 0]
      const initUpDir = [0, 0, 1]
      const initRightDir = Vec3.normalize(Vec3.cross(initFrontDir, initUpDir))

      const upDir = [0, 0, 1]
      const nextTimePos = [nextTimePosition.point[0], nextTimePosition.point[1], 0]
      const firstTimePos = [timePosition.point[0], timePosition.point[1], 0]
      const frontDir = Vec3.normalize(Vec3.sub(nextTimePos, firstTimePos))
      const angle = Vec3.angleBetween(initFrontDir, frontDir)
      const dt = Vec3.dot(initRightDir, frontDir)
      if (dt < 0) {
        rotMat = Matrix4.makeRotationAxis(angle, upDir)
      } else {
        rotMat = Matrix4.makeRotationAxis(-angle, upDir)
      }
      // 旋转矩阵转换为四元数
      const quat = Quat.fromRotationMatrix(rotMat)
      // 添加旋转关键帧
      // await player.Native.KeyframeTrack.keyAppend(trackR, timePosition.time, quat)
      const tempR = {
        keyframeTrack: trackR,
        time: timePosition.time,
        value: quat,
      }
      trackRList.push(tempR)
    }
  }
  // console.log('batchkeyAppend', trackTList, trackRList)
  player.Native.KeyframeTrack.batchKeyAppend(trackTList)
  player.Native.KeyframeTrack.batchKeyAppend(trackRList)
}
/**
 * @description: 添加关键帧,设置人物动画
 * @param {*} clip 动画片段对象
 * @param {*} personNode 人物节点
 * @param {*} timePositions 时间与点对应的集合
 * @return {*}
 */
const loadKeyframeTrack = async (clip, personNode, timePositions, player) => {
  // 获取轨道个数
  const clipTrackCount = await player.Native.KeyframeTrack.trackCount(clip)
  if (clipTrackCount > 0) {
    // 清除所有轨道数据
    await player.Native.KeyframeTrack.clearTrack(clip)
  }
  // 创建位置关键帧轨道
  const trackT = await player.Native.KeyframeTrack.addTrackWithParam(clip, personNode, {
    name: 'trackLocalTranslation', // 轨道名称
    trackType: EnumKFTTReal3, // 轨道类型 : [x,y,z](double3) 数据类型轨道
    propertyLinkType: EnumAPBTTranslation, // 轨道属性链接类型: 位置链接
    interpolationType: EnumITLinear, // 轨道差值方式: 线性插值
  })
  // 创建旋转关键帧轨道
  const trackR = await player.Native.KeyframeTrack.addTrackWithParam(clip, personNode, {
    name: 'trackLocalRotation', // 轨道名称
    trackType: EnumKFTTQuaternion, // 轨道类型 : [w, x,y,z](quaternion,四元数) 数据类型轨道
    propertyLinkType: EnumAPBTRotation, // 轨道属性链接类型: 旋转链接
    interpolationType: EnumITDiscrete, // 轨道差值方式: 离散插值
  })
  // 清除所有关键帧
  await player.Native.KeyframeTrack.keyClear(trackT)
  await player.Native.KeyframeTrack.keyClear(trackR)
  await addKeyframe(timePositions, trackT, trackR, player)
  return {
    trackR,
    trackT,
  }
}

const loadAction = async (data, mixer, personName, player) => {
  // 创建动画片段对象
  const clip = await player.Native.AnimationClip.getClip(mixer, personName)
  // 获取动画片段动作控制器
  const action = await player.Native.AnimationAction.clipAction(mixer, clip)
  // 获取动画片段控制器
  // 绑定动画片段更新通知
  player.Native.AnimationAction.bindActionUpdate(action)
  // 设置为非循环模式播放
  player.Native.AnimationAction.setLoop(action, EnumLMLoopOnce, -1)

  const KeyframeTrackObj = await loadKeyframeTrack(clip, data.nodePtr, data.timePositions, player)
  return {
    action,
    clip,
    ...KeyframeTrackObj,
  }
}

const appendKeyframeTrack = async (actionData, timePositions) => {
  const keyTimeT = await player.Native.KeyframeTrack.keyTimes(actionData.trackT)
  const removeKeyConst = keyTimeT.length - timePositions.length
  if (removeKeyConst > 0) {
    await player.Native.KeyframeTrack.keyRemoveByRange(actionData.trackT, 0, removeKeyConst)
    await player.Native.KeyframeTrack.keyRemoveByRange(actionData.trackR, 0, removeKeyConst)
  }
  // 获取之前的关键帧个数,如果关键帧非空，则需要将已有关键帧的最后一帧添加到新增关键帧列表中，以正确计算旋转(人物朝向)
  const bTrackTEmpty = await player.Native.KeyframeTrack.empty(actionData.trackT)
  if (!bTrackTEmpty) {
    const lTime = await player.Native.KeyframeTrack.lastTime(actionData.trackT)
    const lValue = await player.Native.KeyframeTrack.lastValue(actionData.trackT)
    timePositions.unshift({
      time: lTime,
      point: lValue,
    })
  }
  // 追加关键帧
  await addKeyframe(timePositions, actionData.trackT, actionData.trackR)
}
export {
  loadAction, loadKeyframeTrack, appendKeyframeTrack, addKeyframe
}
